import {
  PDFLabelSet,
  type OrderItemLabels,
  type POLabels,
} from '../../entities/PDFLabelSet'

export const procurifyDefaultPDFLabelSet = new PDFLabelSet({
  isPrimary: false,
  key: 'procurify',
  value: {
    name: 'Procurify System Label Set',
    orderitem: {} as OrderItemLabels,
    po: {} as POLabels,
  },
})

export const filterLabelsByRegex = (
  searchTerm: string,
  labelSets: PDFLabelSet[]
) => {
  const labelToFind = new RegExp(searchTerm, 'gi')
  return labelSets.filter((label) => labelToFind.test(label.value.name))
}

export const sortPDFLabelSetsAlphabetically = (labelSets: PDFLabelSet[]) => {
  return labelSets.sort((a, b) => a.value.name.localeCompare(b.value.name))
}
